import { GlobalStorage, globalStorage } from "./storage";
import { o_global } from "../../browser/head/namespaces.js";

/*                                              */
o_global.Storage ||= GlobalStorage;
o_global.globalStorage ||= globalStorage;
